module.exports = __webpack_public_path__ + "static/go-mobile-561f7d7213270e8fa3dbfa8e36d5bdef.png";